<!--<hr />-->
<div class="jumbotron hidden-xs hidden-sm" data-testid="strike-details-main-div">
  <div class="col-md-3 container text-center">
    <div class="pull-left col-md-6" style="padding:0" *ngIf="strike.weekNumber>0">
      <div class="container text-center" style="border-radius:  15px 40px 15px 15px;background: #c6e59b;height: 100px; padding:0 0 0 0;">
        <div style="height:80px; padding:0">
          <span style="font-family:Castellar; font-size:70px; color:lightcyan; " data-testid="strike-details-week">{{strike.weekNumber}}</span>
        </div>
        <span style="font-family:Castellar; font-size:medium; color:lightcyan">Week</span>
      </div>
    </div>
    <div class="pull-right col-md-6" style="padding:0" *ngIf="strike.dayNumber>0">
      <div class="container text-center" style="border-radius:  40px 15px 15px 15px;background: #c6e59b;height: 100px; padding:0 0 0 20px;">
        <div style="height:80px">
          <span style="font-family:Castellar; font-size:70px; color:lightcyan;" data-testid="strike-details-day">{{strike.dayNumber}}</span>
        </div>
        <span style="font-family:Castellar; font-size:medium; color:lightcyan">Day</span>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="container text-center">
      <h1 data-testid="strike-details-title">{{strike.Title}}</h1>
      <div class="text-center" data-testid="strike-details-comments"><i><i class="fa fa-quote-left"></i>{{strike.Comments}}<i class="fa fa-quote-right"></i></i></div>
      <br />
      <div class="btn-group">
        <a [routerLink]="'/strikewalk/strike/' + strike.ID" data-testid="walk-history-link" class="btn btn-sm btn-primary">Walk History<i class="fa fa-book pull-right"></i></a>
        <a [routerLink]="'/strikes/edit/' + strike.ID" data-testid="edit-walk-link" class="btn btn-sm btn-default">Edit strike<i class="fa fa-pencil-square-o pull-right"></i></a>
      </div> <!-- end btn-group -->
    </div> <!-- end container -->
  </div>
  <div class="col-md-3">
    <div class="container text-right">
      <div class="media">
        <div class="media-body" data-testid="strike-details-strike-info">
          Started On: <span data-testid="strike-details-startdate">{{strike.StartDate | date:"MM/dd/yyyy"}}</span><br />
          <div *ngIf="strike.EndDate !== null">Ended On: <span data-testid="strike-details-enddate">{{strike.EndDate | date:"MM/dd/yyyy"}}</span><br /></div>
          Min Threshold (Hours): <span data-testid="strike-details-minhours">{{strike.MinThresholdHours}}</span><br />
          Min Threshold (Days): <span data-testid="strike-details-mindays">{{strike.MinThresholdDays}}</span><br />
          Participation Benefit: <span data-testid="strike-details-participation">{{strike.ParticipationBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</span><br />
          Helper Benefit: <span data-testid="strike-details-helper">{{strike.HelperBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</span><br />
          <br />
          <span class="label label-info">Last Week</span>
          Min Threshold (Hours): <span data-testid="strike-details-last-minhours">{{strike.LastWeekMinThresholdHours}}</span><br />
          Min Threshold (Days): <span data-testid="strike-details-last-mindays">{{strike.LastWeekMinThresholdDays}}</span><br />
          Participation Benefit: <span data-testid="strike-details-last-participation">{{strike.LastWeekParticipationBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</span><br />
          Helper Benefit: <span data-testid="strike-details-last-helper">{{strike.LastWeekHelperBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</span><br />
        </div>
      </div>
    </div>
  </div>
</div>


<div class="col-xs-12 col-sm-12">
  <div class="col-xs-12 col-sm-12">
    <div class="container text-left  hidden-md hidden-lg">
      <div class="btn-group">
        <a [routerLink]="'/strikewalk/strike/' + strike.ID" class="btn btn-sm btn-primary">Walk History<i class="fa fa-book pull-right"></i></a>
      </div> <!-- end btn-group -->
    </div> <!-- end container -->
  </div>

  <div class="col-xs-12 col-sm-12 col-md-6">
    <div class="panel panel-primary hidden-xs hidden-sm" data-testid="strike-houses">
      <div class="panel-heading">
        <div class="col-xs-9"><h5>Property/House</h5></div>
        <button type="button" (click)="openAddHouseModal();" class="btn btn-sm btn-primary" data-testid="add-house-modal-button">Add House<i class="fa fa-book pull-right"></i></button>
      </div>
      <!-- <div class="panel-body" >-->
      <div class="table-responsive" *ngIf="strikeHouses.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th colspan="2"># of Mbrs</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr data-testid="houses-table" *ngFor="let house of strikeHouses ">
              <td [attr.data-testid]="'houseid-' + house.ID">{{house.HouseId}}</td>
              <td [attr.data-testid]="'housename-' + house.ID">{{house.HouseName}}</td>
              <td style="text-align:right"><a [routerLink]="'/strikemembers/strikehouse/' + house.ID" [attr.data-testid]="'view-members-link-' + house.ID" title="View {{house.HouseName}} members"> {{house.NoOfEmployees}} </a></td>
              <td> <a [routerLink]="'/strikemembers/registration/house/' + house.ID" class="btn btn-xs btn-default" [attr.data-testid]="'view-registration-link-' + house.ID" >Registration<i class="fa fa-credit-card-alt"></i></a> </td>
              <td class="text-center">
                <button type="button" class="btn btn-primary btn-xs" (click)="refreshData(house)" data-testid="refresh-button">Refresh</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </div> -->
    </div>
    <div class="panel panel-primary  hidden-xs hidden-sm" data-testid="strike-shifts">
      <div class="panel-heading">
        <div class="col-md-9"><h5>Shifts</h5></div>
        <button type="button" (click)="openAddShiftModal();" class="btn btn-sm btn-primary" data-testid="add-shift-modal-button">Add Shift<i class="fa fa-book pull-right"></i></button>
      </div>
      <!-- <div class="panel-body" >-->
      <div class="table-responsive"  *ngIf="strikeShifts.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th style="text-align:right">Start Hour</th>
              <th style="text-align:right">End Hour</th>
            </tr>
          </thead>
          <tbody>
            <tr data-testid="shifts-table" *ngFor="let shift of strikeShifts, let i = index">
              <td [attr.data-testid]="'shift-name-'+ i">{{shift.ShiftName}}</td>
              <td style="text-align:right" [attr.data-testid]="'shift-starthour-'+ i">{{shift.StartHour}}</td>
              <td style="text-align:right" [attr.data-testid]="'shift-endhour-' + i">{{shift.EndHour}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </div> -->
    </div>
    <div class="panel panel-primary hidden-xs hidden-sm" data-testid="reports-section">
      <div class="panel-heading">
        <h5>Reports</h5>
      </div>
      <div class="panel-body">
        <div class="table-responsive pull-left col-md-6">
          <table class="table table-striped">
            <tbody>
              <tr data-testid="reports-left-table" *ngFor="let rep of reportsLeft">
                <td ><button type="button" [attr.data-testid]="'report-button-' + rep.repDescr" style="width:100%;" (click)="openReportsModal(rep);" class="btn btn-sm btn-primary" ng-if="rep.repDescr != ''">{{rep.repDescr}}<i class="fa fa-book pull-right"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive pull-right col-md-6">
          <table class="table table-striped">
            <tbody>
              <tr data-testid="reports-right-table" *ngFor="let rep of reportsRight">
                <td><button type="button" [attr.data-testid]="'report-button-' + rep.repDescr" style="width:100%;" (click)="openReportsModal(rep)" class="btn btn-sm btn-primary" ng-if="rep.repDescr != ''">{{rep.repDescr}}<i class="fa fa-book pull-right"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-sm-12 col-md-6" data-testid="picketlines-section">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <div class="row">
          <div class="hidden-lg hidden-md">
            <h3><span style="font-weight:bold">{{strike.Title}}</span></h3>
          </div>
          <div class="col-md-3">
            <h5>Picket Check-in Locations</h5>
          </div>
          <div class="col-md-9 hidden-xs hidden-sm">
            <!--<button type="button" ng-click="uploadTracerPlusData();" class="btn btn-sm btn-primary">Upload TPLUS data<i class="fa fa-upload pull-left" aria-hidden="true"></i></button>-->
            <button type="button" (click)="openAddPicketlineModal();" class="btn btn-sm btn-primary pull-right" data-testid="add-picketline-modal-button">Add Picketline<i class="fa fa-book pull-right"></i></button>
          </div>
        </div>
      </div>

      <div class="hidden-md-up" *ngIf="strikePicketlines.length === 1">
        <table class="table table-striped">
          <tbody>
            <tr *ngFor="let picketline of strikePicketlines ">
              <td>
                <div class="col-sm-4">
                  <br />
                  <a [routerLink]="'/signin/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName" [attr.data-testid]="'picketline-signin-button-' + picketline.ID" class="btn btn-large btn-success" style="width:50%;">Sign In <br />LLegar</a>
                  <br />
                </div>
                <div class="col-sm-4">
                  <a [routerLink]="'/signout/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName" [attr.data-testid]="'picketline-signout-button-' + picketline.ID" class="btn btn-large btn-danger" style="width:50%;"><i>Sign OUT <br />Salir</i></a>
                  <br />
                </div>
                <div class="col-sm-4">
                  <a [routerLink]="'/manualentry/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName" [attr.data-testid]="'picketline-manual-button-' + picketline.ID"  class="btn btn-large btn-info" style="width:50%;">Manual</a>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="hidden-md-up" *ngIf="strikePicketlines.length > 1">
        <table class="table table-striped">
          <tbody>
            <tr data-testid="picketlines-table" *ngFor="let picketline of strikePicketlines ">
              <td>
                <h2 [attr.data-testid]="'picketline-name-' + picketline.ID"> {{picketline.PicketLineName}}</h2>
                <div class="col-sm-4">
                  <a [routerLink]="'/signin/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName"  [attr.data-testid]="'signin-link-' + picketline.ID" class="btn btn-large btn-success " style="width:50%;">Sign In <br />LLegar</a>
                  <br />
                </div>
                <div class="col-sm-4">
                  <a [routerLink]="'/signout/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName" [attr.data-testid]="'signout-link-' + picketline.ID" class="btn btn-large btn-danger " style="width:50%;">Sign OUT <br />Salir</a>
                  <br />
                </div>
                <div class="col-sm-4">
                  <a [routerLink]="'/manualentry/strike/' + picketline.StrikeInfoId + '/picketline/' + picketline.ID + '/' + picketline.PicketLineName" [attr.data-testid]="'manual-link-' + picketline.ID" class="btn btn-large btn-info " style="width:50%;">Manual<br /> &nbsp;</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

</div>

<div class="col-xs-12 col-sm-12 col-md-6" data-testid="walk-summary-section">

  <div class="panel panel-primary  hidden-xs hidden-sm">
    <div class="panel-heading">
      <h5>Member Walk Summary for last {{walkSummary.length}} weeks</h5>
    </div>
    <!-- <div class="panel-body" >-->
    <div class="table-responsive" *ngIf="walkSummary.length > 0">
      <table class="table table-striped table-bordered" style="text-align:right; font-size:12px;">
        <thead>
          <tr>
            <th>Week #</th>
            <th>Week</th>
            <th>One Day</th>
            <th>Two Days</th>
            <th>Three Days</th>
            <th>Four Days</th>
            <th>Five Days</th>
            <th>Six Days</th>
            <th>Seven Days</th>
            <th>Total Mbrs</th>
          </tr>
        </thead>
        <tbody>
          <tr data-testid="walksummary-table" *ngFor="let wk of walkSummary">
            <td data-testid="walksummary-weekno">{{wk.WeekNo}}</td>
            <td data-testid="walksummary-walkweek">{{wk.WalkWeek | date:'MM/dd/yy'}}</td>
            <td data-testid="walksummary-1">{{wk.OneDay}}</td>
            <td data-testid="walksummary-2">{{wk.TwoDays}}</td>
            <td data-testid="walksummary-3">{{wk.ThreeDays}}</td>
            <td data-testid="walksummary-4">{{wk.FourDays}}</td>
            <td data-testid="walksummary-5">{{wk.FiveDays}}</td>
            <td data-testid="walksummary-6">{{wk.SixDays}}</td>
            <td data-testid="walksummary-7">{{wk.SevenDays}}</td>
            <td data-testid="walksummary-total">{{wk.Total}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>




<div class="col-xs-12 col-sm-12 col-md-6" data-testid="week-summary-section">

  <div class="panel panel-primary hidden-xs hidden-sm">
    <div class="panel-heading">
      <h5>Week Summary for last {{weekSummary.length}} weeks</h5>
    </div>
    <!-- <div class="panel-body" >-->
    <div class="table-responsive" *ngIf="weekSummary.length > 0" style="text-align:right; font-size:12px;">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Week #</th>
            <th>Week</th>
            <th>First Day</th>
            <th>Second Day</th>
            <th>Third Day</th>
            <th>Fourth Day</th>
            <th>Fifth Day</th>
            <th>Sixth Day</th>
            <th>Seventh Day</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr data-testid="weeksummary-table" *ngFor="let wd of weekSummary" style="text-align:right; font-size:12px;">
            <td data-testid="weeksummary-weekno">{{wd.WeekNo}}</td>
            <td data-testid="weeksummary-walkweek">{{wd.WalkWeek | date:'MM/dd/yy'}}</td>
            <td data-testid="weeksummary-1">{{wd.FirstDay}}</td>
            <td data-testid="weeksummary-2">{{wd.SecondDay}}</td>
            <td data-testid="weeksummary-3">{{wd.ThirdDay}}</td>
            <td data-testid="weeksummary-4">{{wd.FourthDay}}</td>
            <td data-testid="weeksummary-5">{{wd.FifthDay}}</td>
            <td data-testid="weeksummary-6">{{wd.SixthDay}}</td>
            <td data-testid="weeksummary-7">{{wd.SeventhDay}}</td>
            <td data-testid="weeksummary-total">{{wd.Total}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
